import { getEcCom } from '../util/convert';
const { WeaTools } = getEcCom();
const staticVersion = `?v=${WeaTools && WeaTools.ls && WeaTools.ls.getStr("staticVersion") || 0}`;

export const antdFiles = [
    `/cloudstore/resource/pc/com/v1/index.min.js${staticVersion}`,
]

export const ecComFiles = [
    `/cloudstore/resource/pc/com/v1/ecCom.min.js${staticVersion}`,
]

export const comMobxFiles = [
    `/spa/coms/index.mobx.js${staticVersion}`
]

export const odocFiles = [
    `/formmode/js/CryptoJS3.1.2/aes_wev8.js${staticVersion}`,//加密预先加载
    `/js/odoc/common/DocUtil_e9.js${staticVersion}`,    //公文模块对接
    `/js/odoc/common/OdocRightBtn.js${staticVersion}`,    //公文模块对接
    `/odoc/odoc/js/wps_sdk.js${staticVersion}`,
    `/js/odoc/common/wpsJsApi.js${staticVersion}`,    //公文模块对接
    `/js/odoc/common/iweboffice2015Util.js${staticVersion}` //公文对接金格弹出框模式websocket
]

export const odocComsFiles = [
    `/spa/odoc/static/index.js${staticVersion}`,    //公文模块对接
    `css!/spa/odoc/static/index.css${staticVersion}`,    //公文模块对接
]

export const dependFiles = [
    `/spa/workflow/async/zDialog_wev8.js${staticVersion}`,
    `/js/doc/workflow_form_doc_operation.js${staticVersion}`,   //文档模块对接
    `/spa/hrm/eventListener.js${staticVersion}`,    //人力资源模块对接
    `/social/js/drageasy/drageasy.js${staticVersion}`,
    `/social/js/bootstrap/js/bootstrap.js${staticVersion}`,
    `/social/im/js/IMUtil_wev8.js${staticVersion}`,
    `/social/js/imcarousel/imcarousel.js${staticVersion}`,
]

export const escFiles = [
    `/formmode/js/CryptoJS3.1.2/mode_ecb_wev8.js${staticVersion}`,
    `/js/weaver_encrypt/jsencrypt_wev.js${staticVersion}`,
    `/js/weaver_encrypt/weaver_encrypt.js${staticVersion}`,
    `/js/weaver_encrypt/weaver_encrypt_ctrl.js${staticVersion}`
]



export const workflowPublicFiles = [
    `/spa/workflow/static4public/index.js${staticVersion}`,
    `css!/spa/workflow/static4public/index.css${staticVersion}`
];

export const workflowFiles = [
    `/spa/workflow/static/index.js${staticVersion}`,
    `css!/spa/workflow/static/index.css${staticVersion}`
];

export const portalFiles = [
    `/spa/portal/public/index.js${staticVersion}`,
    `css!/spa/portal/public/index.css${staticVersion}`,
    `/spa/portal/static/index.js${staticVersion}`,
    `css!/spa/portal/static/index.css${staticVersion}`
];

export const hrmFiles = [
    `/spa/hrm/static4enginePublic/engine.js${staticVersion}`
];

export const fnaFiles = [
    `/spa/fna/fnaSpecial/index_mobx.js${staticVersion}`,
    `/spa/fna/static/index.js${staticVersion}`,
    `css!/spa/fna/static/index.css${staticVersion}`
];

export const smsFiles = [
    `/spa/smallApp/static/index.js${staticVersion}`,
    `css!/spa/smallApp/static/index.css${staticVersion}`
];

export const communicationFiles = [
    `css!/blog/js/weaverImgZoom/weaverImgZoom_wev8.css${staticVersion}`,
    `/blog/js/weaverImgZoom/weaverImgZoom_wev8.js${staticVersion}`
];

export const emailFiles = [
    `/spa/email/static/index.js${staticVersion}`,
    `css!/spa/email/static/index.css${staticVersion}`
];

export const excelDesignFiles = [
    `/spa/workflow/excelDesign/engine.js${staticVersion}`,
    `css!/spa/workflow/excelDesign/engine.css${staticVersion}`,
];


// WEBPACK FOOTER //
// ../src4js/pc4mobx/workflowForm/constants/fileConfig.js